<main animate.enter="ds-fade-enter" animate.leave="ds-fade-leave">
    <div dsTextOverflow
        class="text-container">
        <ds-slide-text [slide]="slide()"
            [controller]="controller()" />
    </div>
    <div class="image-container"
        [ngStyle]="{ 'background-image': background() }">
        <svg id="svg-oval"
            viewBox="910 0 270 1080"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M-1973.17 1057.75C-1355.26 1850.14 -261.87 2030.48 468.984 1460.56C1199.84 890.644 1291.4 -213.723 673.5 -1006.11C55.5976 -1798.5 -46.5581 14.0454 -777.412 583.964C-1508.27 1153.88 -2591.07 265.366 -1973.17 1057.75Z"
                fill="var(--ds-color-surface, #1b2431)" />
        </svg>
    </div>
</main>
<div class="fade-overlay"></div>
